<template>
  <div class="card mb-25 border-0 rounded-0 bg-white daily-payments-chart">
    <div class="card-body p-15 p-sm-20 p-sm-25 p-lg-30 letter-spacing">
      <div
        class="mb-lg-15 d-sm-flex align-items-center justify-content-between"
      >
        <h6 class="card-title fw-bold mb-0">Point journalier des paiements (30 derniers jours)</h6>
       
      </div>
      <div id="dailyPaymentsChart" class="chart">
        <apexchart
          type="bar"
          height="300"
          :options="dailyPaymentsChart"
          :series="dailyPayments"
        ></apexchart>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent,ref,onMounted } from "vue";
import axios from 'axios';

export default defineComponent({
  name: "DailyPaymentsChart",
  setup: () => {
    const donnees = ref<Array<number>>([]);
    const dates = ref<Array<string>>([]);
    const references = ref([]);
    
    const fetchDailyPayments = async () => {
      try {
        const response = await axios.get(`etats/paiements/point-journalier`);
        references.value = response.data.data;
        return references.value;
      } catch (error) {
        console.error('Erreur lors de la récupération des données journalières:', error);
      }
    }
    
    const formatDate = (dateString: string) => {
      const date = new Date(dateString);
      return date.toLocaleDateString('fr-FR', { 
        day: '2-digit', 
        month: '2-digit' 
      });
    };
    
    onMounted(async () => {
      await fetchDailyPayments();
      references.value.forEach((element: any) => {
        ajouterNouvellesValeurs(formatDate(element.datePaiement), parseInt(element.montantTotal));
      });
    });
    
    function ajouterNouvellesValeurs(date: string, valeur: number) {
      donnees.value.push(valeur);
      dates.value.push(date);
    }

    return {
      donnees,
      dates,
      references,
      dailyPayments: [
        {
          name: "Montant des paiements (FCFA)",
          data: donnees.value,
        },
      ],
      dailyPaymentsChart: {
        chart: {
          toolbar: {
            show: true,
          },
        },
        plotOptions: {
          bar: {
            borderRadius: 0,
            horizontal: false,
            columnWidth: "60%",
            endingShape: "rounded",
          },
        },
        dataLabels: {
          enabled: true,
          formatter: function (val: any) {
            return new Intl.NumberFormat('fr-FR').format(val);
          }
        },
        colors: ["#0a59a4"],
        stroke: {
          show: true,
        },
        xaxis: {
          categories: dates.value,
          labels: {
            show: true,
            style: {
              fontFamily: "Red Hat Display, sans-serif",
              colors: "#9C9AB6",
              fontSize: "12px",
              fontWeight: 500,
            },
            rotate: -45,
            rotateAlways: false,
          },
        },
        yaxis: {
          show: true,
          tickAmount: 8,
          labels: {
            show: true,
            style: {
              fontFamily: "Red Hat Display, sans-serif",
              colors: ["#9C9AB6"],
              fontSize: "14px",
              fontWeight: 500,
            },
            formatter: function (val: any) {
              return new Intl.NumberFormat('fr-FR').format(val);
            }
          },
        },
        fill: {
          opacity: 1,
        },
        tooltip: {
          style: {
            fontSize: "14px",
            fontFamily: "Red Hat Display, sans-serif",
          },
          y: {
            formatter: function (val: any) {
              return new Intl.NumberFormat('fr-FR').format(val) + " FCFA";
            }
          }
        },
        grid: {
          show: true,
          strokeDashArray: 5,
          borderColor: "#d9e9ef",
        },
      },
    };
  },
});
</script>
